import script from "./IndustryPosition.vue?vue&type=script&setup=true&lang=js"
export * from "./IndustryPosition.vue?vue&type=script&setup=true&lang=js"

import "./IndustryPosition.vue?vue&type=style&index=0&id=5479a0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5479a0b2"]])

export default __exports__